import React from 'react';
import { createRoot } from 'react-dom/client'; // Import createRoot
import App from './App';
import './variables.css';
import 'antd/dist/reset.css';
import './global.css';

const container = document.getElementById('root');
const root = createRoot(container); // Create a root

root.render(<App />);
